import type {
  CTAEvent,
  TodoStart,
  AnalyticsPayload,
} from 'yo-services/yolabs/analytics/yoanalytics/analytics_events_pb';

// The 2 enums below are intentionally different than the values defined in the protos
// see: GG-242
export enum TodoEntryPoint {
  TODO_ENTRY_POINT_UNSPECIFIED = 'TODO_ENTRY_POINT_UNSPECIFIED',
  TODO_ENTRY_POINT_MENU = 'TODO_ENTRY_POINT_MENU',
  TODO_ENTRY_POINT_CATEGORY_FEATURE = 'TODO_ENTRY_POINT_CATEGORY_FEATURE',
  TODO_ENTRY_POINT_CATEGORY_SUBCATEGORY = 'TODO_ENTRY_POINT_CATEGORY_SUBCATEGORY',
  TODO_ENTRY_POINT_HOME_FEATURE = 'TODO_ENTRY_POINT_HOME_FEATURE',
  TODO_ENTRY_POINT_HOME_SUBCATEGORY = 'TODO_ENTRY_POINT_HOME_SUBCATEGORY',
  TODO_ENTRY_POINT_TODO_DISCOVERY = 'TODO_ENTRY_POINT_TODO_DISCOVERY',
}

export enum TodoType {
  TODO_TYPE_UNSPECIFIED = 'TODO_TYPE_UNSPECIFIED',
  TODO_TYPE_A = 'TODO_TYPE_A',
  TODO_TYPE_B = 'TODO_TYPE_B',
  TODO_TYPE_C = 'TODO_TYPE_C',
}

// yo-services/yolabs/analytics/yoanalytics/analytics_events_pb.d.ts (CTA.Action)
export enum Action {
  ACTION_UNSPECIFIED = 'ACTION_UNSPECIFIED',
  ACTION_ONBOARDING_TUTORIAL_VIEWED = 'ACTION_ONBOARDING_TUTORIAL_VIEWED',
  ACTION_LANDING_OPTIONS_TO_MESSAGES = 'ACTION_LANDING_OPTIONS_TO_MESSAGES',
  ACTION_LANDING_DETAILS_TO_MESSAGES = 'ACTION_LANDING_DETAILS_TO_MESSAGES',
  ACTION_RECURRING_SKIP_ONCE = 'ACTION_RECURRING_SKIP_ONCE',
  ACTION_RECURRING_CANCEL = 'ACTION_RECURRING_CANCEL',
  ACTION_SIGNUP_V2_COMPLETED = 'ACTION_SIGNUP_V2_COMPLETED',
  ACTION_LINK_CLICKED = 'ACTION_LINK_CLICKED',
  ACTION_EMPLOYER_LANDING_PAGE_WHITEPAPER_SUBMIT = 'ACTION_EMPLOYER_LANDING_PAGE_WHITEPAPER_SUBMIT',
  ACTION_EMPLOYER_LANDING_PAGE_INTEREST_FORM_SUBMIT = 'ACTION_EMPLOYER_LANDING_PAGE_INTEREST_FORM_SUBMIT',
  ACTION_TODO_DISCOVERY_SEARCH_ENTERED = 'ACTION_TODO_DISCOVERY_SEARCH_ENTERED',
  ACTION_TODO_DISCOVERY_SEARCH_EXIT = 'ACTION_TODO_DISCOVERY_SEARCH_EXIT',
  ACTION_TODO_DISCOVERY_SEARCH_CANCEL = 'ACTION_TODO_DISCOVERY_SEARCH_CANCEL',
  ACTION_TODO_DISCOVERY_SEARCH_TRIGGERED = 'ACTION_TODO_DISCOVERY_SEARCH_TRIGGERED',
  ACTION_TODO_DISCOVERY_ENTERED = 'ACTION_TODO_DISCOVERY_ENTERED',
}

export type WrappedExternalEvent = Omit<
  AnalyticsPayload.ExternalEvent.AsObject,
  'cta' | 'todoStart'
> & {
  cta?: Omit<CTAEvent.AsObject, 'action'> & { action: Action };
  todoStart?: Omit<TodoStart.AsObject, 'entryPoint' | 'type'> & {
    entryPoint: TodoEntryPoint;
    type: TodoType;
  };
};
